//----------------------------------
// Imports
//----------------------------------
import Vue from 'vue';
import api from './api';
import meta from './meta';
import config from './config';
import google from './analytics/google';

const { APP_ENV, APP_BASE_URL, APP_CONTENT_URL, LANGUAGES } = config;
const reactiveVm = new Vue({ data: { bData: null, clientWidth: window.innerWidth } });
const bones = {
  analytics: google,
  api,
  meta,
  env: APP_ENV,
  contentUrl: (APP_CONTENT_URL === '/') ? '' : APP_CONTENT_URL,
  baseUrl: (APP_BASE_URL === '/') ? '' : APP_BASE_URL,
  languages: LANGUAGES,
  install: () => {
    Object.defineProperty(bones, 'data', {
      get() { return reactiveVm.bData; },
      set(value) { reactiveVm.bData = value; },
    });
    Object.defineProperty(Vue.prototype, '$b', {
      get() { return bones; },
    });
    Object.defineProperty(bones, 'clientWidth', {
      get() { return reactiveVm.clientWidth; },
    });
    window.onresize = () => {
      reactiveVm.clientWidth = window.innerWidth;
    };
    // remove method so we don't expose it after it has been used
    delete bones.install;
  },
};

Vue.use(bones);

export default bones;
